import React, { useState, useEffect } from "react";
import classnames from "classnames/bind";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { setMeta } from "src/redux/meta/actions";
import css from "./BootstrapNavbar.scss";

const cx = classnames.bind(css);
const moduleName = "BootstrapNavbar";

const NAV_ITEMS = [
  { to: "/room",        label: "객실 소개",    en: "Rooms" },
  { to: "/surrounding", label: "주변 전경",    en: "Surroundings" },
  { to: "/facility",    label: "부대 시설",    en: "Facility" },
  { to: "/board",       label: "추억 만들기",  en: "Memories" },
  { to: "/reservation", label: "예약 안내",    en: "Reservation" },
  { to: "/direction",   label: "오시는 길",    en: "Direction" },
];

const BootstrapNavbar = ({ meta }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // 드로어 열릴 때 body 스크롤 방지
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <div className={cx(moduleName)}>
      {/* ─── 상단 바 ─── */}
      <nav className={cx(`${moduleName}-bar`, { scrolled })}>
        <a href="/" className={cx(`${moduleName}-brand`)}>
          스테이 무릉도원
        </a>

        {/* 데스크탑 메뉴 */}
        <ul className={cx(`${moduleName}-desktop-nav`)}>
          {NAV_ITEMS.map((item) => (
            <li key={item.to}>
              <Link to={item.to} className={cx(`${moduleName}-desktop-link`)}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* 햄버거 버튼 */}
        <button
          className={cx(`${moduleName}-burger`, { open })}
          onClick={() => setOpen((v) => !v)}
          aria-label="메뉴"
        >
          <span /><span /><span />
        </button>
      </nav>

      {/* ─── 드로어 오버레이 ─── */}
      <div className={cx(`${moduleName}-overlay`, { open })} onClick={close} />

      {/* ─── 드로어 패널 ─── */}
      <div className={cx(`${moduleName}-drawer`, { open })}>
        <div className={cx(`${moduleName}-drawer-header`)}>
          <p className={cx(`${moduleName}-drawer-brand`)}>스테이 무릉도원</p>
          {meta.isLogined && (
            <p className={cx(`${moduleName}-drawer-logined`)}>주인장님 안녕하세요</p>
          )}
        </div>

        <nav className={cx(`${moduleName}-drawer-nav`)}>
          {NAV_ITEMS.map((item, i) => (
            <Link
              key={item.to}
              to={item.to}
              className={cx(`${moduleName}-drawer-item`)}
              style={{ transitionDelay: open ? `${i * 60}ms` : "0ms" }}
              onClick={close}
            >
              <span className={cx(`${moduleName}-drawer-item-en`)}>{item.en}</span>
              <span className={cx(`${moduleName}-drawer-item-kr`)}>{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className={cx(`${moduleName}-drawer-footer`)}>
          <a href="tel:01047386659" className={cx(`${moduleName}-drawer-tel`)} onClick={close}>
            010-4738-6659
          </a>
          <Link to="/admin" className={cx(`${moduleName}-drawer-admin`)} onClick={close}>
            관리자
          </Link>
        </div>
      </div>
    </div>
  );
};

export default connect(
  ({ meta }) => ({ meta }),
  { setMeta }
)(BootstrapNavbar);



// WEBPACK FOOTER //
// ./src/App/pages/Home/components/BootstrapNavbar.js